export default "__VITE_ASSET__CnwW1Qbp__"